import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { COUNTERS, USPS, YEARS } from "./data";
import { Reveal, SectionHead } from "./Reveal";
import { Counter } from "./Counter";
import { imgSrc } from "./Pic";

const GableImage = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-9%", "9%"]);
  return (
    <div ref={ref} className="relative lg:col-span-5">
      <Reveal>
        <div className="gable relative aspect-[4/5] overflow-hidden bg-ink2">
          <motion.img style={{ y }} {...imgSrc("roofers-slate")} sizes="(max-width: 1024px) 100vw, 40vw" alt="Dachdecker bei der Arbeit an einem Schieferdach" loading="lazy" className="absolute -top-[10%] left-0 h-[120%] w-full object-cover" />
        </div>
      </Reveal>
      <Reveal delay={0.25} className="absolute -bottom-8 right-4 sm:-right-6">
        <div className="bg-terra-deep px-7 py-6 text-white shadow-2xl">
          <p className="font-display text-5xl font-bold leading-none">{YEARS} Jahre</p>
          <p className="mt-2 text-xs font-semibold uppercase tracking-[0.22em] text-white">Dachhandwerk seit 2008</p>
        </div>
      </Reveal>
    </div>
  );
};

const UspGrid = () => (
  <ul className="mt-12 grid gap-x-10 gap-y-9 sm:grid-cols-2">
    {USPS.map(({ icon: Icon, title, text }, i) => (
      <Reveal key={title} delay={i * 0.07}>
        <li className="group flex gap-5" data-testid={`usp-${i}`}>
          <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full border border-white/15 text-terra transition-colors duration-500 group-hover:border-terra group-hover:bg-terra-deep group-hover:text-white">
            <Icon size={20} strokeWidth={1.6} />
          </span>
          <span>
            <span className="block font-display text-2xl font-bold uppercase leading-none text-white">{title}</span>
            <span className="mt-2 block text-sm leading-relaxed text-slate-300">{text}</span>
          </span>
        </li>
      </Reveal>
    ))}
  </ul>
);

export const About = () => (
  <section id="ueber-uns" aria-labelledby="ueber-title" className="relative overflow-hidden bg-ink py-24 sm:py-32 lg:py-40" data-testid="about-section">
    <div className="tile-pattern absolute inset-0 opacity-60" aria-hidden="true" />
    <div className="relative mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <div className="grid gap-20 lg:grid-cols-12 lg:gap-16">
        <GableImage />
        <div className="lg:col-span-7 lg:pl-8">
          <SectionHead id="ueber-title" eyebrow="Über uns · Warum wir" title={<>Ein Meisterbetrieb<br />mit Bodenhaftung.</>} />
          <Reveal delay={0.15}>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg">
              Seit 2008 decken, sanieren und reparieren wir Dächer in Schifferstadt und der gesamten Region. Wir arbeiten so, wie man es von einem echten Meisterbetrieb erwartet: gründlich, termintreu und mit einem festen Ansprechpartner vom ersten Gespräch bis zur Abnahme.
            </p>
          </Reveal>
          <UspGrid />
        </div>
      </div>
      <div className="mt-28 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:mt-36 lg:grid-cols-4 lg:gap-12">
        {COUNTERS.map((c, i) => <Counter key={c.label} {...c} i={i} />)}
      </div>
    </div>
  </section>
);
